import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SimpleNavBar } from 'components/NavBar/SimpleNavBar';
import { Column } from 'components/UI/Column';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div>
      <SimpleNavBar />
      <Column justifyContent="center" alignItems="center">
        <h2>{t('errors.not found')}</h2>
        <Link to="/products">{t('label.back')}</Link>
      </Column>
    </div>
  );
};

export { NotFound };
